import {bootstrap,element} from 'angular';
import "angular-translate";
import "angular-translate-loader-static-files";
import "angular-ui-router";
import "angular-messages";
import 'angular-animate';
import 'angular-resource';
import 'angular-ui-bootstrap';
import 'angular-material';
import 'angular-material/angular-material.min.css';
import "ui-select/dist/select.js";
import "ui-select/dist/select.css";
import "selectize/dist/css/selectize.bootstrap3.css"
import "angular-sanitize";

require("./forgotlogin.style.scss");
import { Path, AppConfig, AppConfigBlock, AppRunBlock, } from '../../app.config';
import { ModuleUtils } from "../../utils/moduleutils";
import { forgotLoginComponent } from "./forgotlogin.component";
import { ServicesModule } from "../../shared/services/services.module";
import { resetPasswordComponent } from "./views/resetpassword/resetpassword.component";
import { secretQuestionsComponent } from "./views/secretquestions/secretquestions.component";
import { UserPasswordTextBoxModule } from "../../shared/widgets/password/password.module";

const moduleOptions: ngExtendedType.IModuleOptions = {
    components: { forgotLoginComponent, resetPasswordComponent, secretQuestionsComponent },
    configBlocks: [AppConfigBlock],
    runBlocks: [AppRunBlock],
    directives: {},
    injectModules: [UserPasswordTextBoxModule.name, ServicesModule.name, 'ngMaterial', 'ngAnimate', 'ngMessages', 'ngResource', "ui.select", "ngSanitize", 'ui.bootstrap', "pascalprecht.translate", "ui.router"],
    name: AppConfig.ForgotLoginModuleName
};

export let ForgotLoginModule = ModuleUtils.CreateModule(moduleOptions);


class AppBootstrap {

    constructor() {

    }

    private static bootstrap() {
        bootstrap(document, [AppConfig.ForgotLoginModuleName]);
    }

    public static init() {
        element(document).ready(function () {
            //Update External Dependencies
            //if (!_.isUndefined(loadingInterceptor))
            //    loadingInterceptor.intentionalDelay = 1000;

            let appPath: HTMLMetaElement = document.querySelector("meta[name='application-path']") as HTMLMetaElement;

            if (appPath == null || appPath.content == "")
                throw new Error("application path not found in metadata");

            let requestToken: any = document.querySelector('input[name="__RequestVerificationToken"]');

            if (requestToken == null || requestToken == "")
                throw new Error("Request verification token not found");
            
            let assetPath = appPath.content + "Areas/UserManagement/dist/";

            if (!AppVersion)
                throw new Error("AppVersion is not found");

            Path.Provider.SetValue(appPath.content, assetPath, requestToken.value, AppVersion);

            setTimeout(function () {
                AppBootstrap.bootstrap();
            }, 2000);
        });
    }
}

AppBootstrap.init()



